import ReadMore from "./read-more.js";

const initCmsGridList = () => {
  document.querySelectorAll(".cms-grid-list").forEach($section => {

		//Handling Title & Button Wrap Min Heights -------------------------------------------------------------------------

		const colCount = parseInt($section.dataset.cols) || 2

		const $titleEls = Array.from($section.querySelectorAll(".grid-item .item-title"))
		const $btnWraps = Array.from($section.querySelectorAll(".grid-item .btns-wrap"))

		heightHandler()
		window.addEventListener("resize", heightHandler)

		function heightHandler(){
			resetHeights($titleEls)
			window.innerWidth > 1024 ? setupHeight($titleEls, colCount) : resetHeights($titleEls) 
		}


		function setupHeight($els, colCount){ 
			$els.reduce((acc, currentValue, index, originalArray) => {
				index % colCount === 0 && acc.push(originalArray.slice(index, index + colCount))
				return acc;
			}, [])
			.forEach(elSet => {
				const max = Math.max(...elSet.map(el=>parseFloat(el.offsetHeight)))
				elSet.forEach(el => el.style.minHeight = max + "px")
			})
		}
		
		function resetHeights($els){
			$els.forEach(el => el.style.minHeight = "unset")
		}



		//Handling Read More Releted Code ----------------------------------------------------------------------------------
		const $gridItems = Array.from($section.querySelectorAll(".grid-item"))

		$gridItems.forEach($item => {
			const wysiwygEl = $item.querySelector(".description-text")
			const buttonEl = $item.querySelector(".readmore-btn")

      const currentId = $item.dataset.id
	
			const rdMore = new ReadMore({
				sectionEl: $item,
				activeDevices: [1, 1, 1, 1], // Optional
				limitDt : 3,
				limitTbl : 3,
				limitTbp : 3,
				limitMb : 3,
				wysiwygEl: wysiwygEl,
				buttonEl: buttonEl,
				animation: 0.3,
			})

      rdMore.on("beforeExpand", ()=>{
        $gridItems.filter($item => $item.dataset.id != currentId).forEach($item => $item.readMore && $item.readMore.collapse())
      })

      
		})

	})
}

export { initCmsGridList }